import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface MemberListingCardProps {
  resources: Array<{ name: string; email: string }>;
}

export const MemberListingCard = ({ resources }: MemberListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.members_matching")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_members_found")}
    renderItem={member => (
      <>
        <span className="font-bold">{member.name}</span>, {member.email}
      </>
    )}
    getItemKey={member => member.email}
  />
);
